// SEO service × city matrix — one dedicated landing page per (service, city).
// Targets long-tail queries like "fête de Noël entreprise {ville}" and "team building {ville} entreprise".

export const SERVICE_CITIES = {
  paris: {
    name: "Paris",
    region: "Île-de-France",
    coords: { lat: 48.8566, lng: 2.3522 },
    fetesNoel: {
      hook: "Célébrez la fin d'année dans les lieux les plus prestigieux de la capitale.",
      context:
        "Paris concentre les lieux les plus prisés pour vos fêtes de fin d'année d'entreprise : rooftops de La Défense avec vue sur la Tour Eiffel, hôtels particuliers du Marais, monuments privatisables (Musée d'Orsay, Petit Palais, Palais Brongniart) et péniches sur la Seine. Nous privatisons les meilleurs espaces parisiens avec 6 à 12 mois d'anticipation pour vous garantir votre date.",
      venues: [
        "Rooftops La Défense (Terrass Hôtel, Perchoir)",
        "Hôtels particuliers du Marais",
        "Musée d'Orsay & Petit Palais (privatisations)",
        "Péniches privées sur la Seine",
        "Palaces (Ritz, Bristol, Meurice, Four Seasons)",
        "Salles atypiques rive gauche (ex-usines, ateliers d'artistes)",
      ],
    },
    teamBuilding: {
      hook: "Fédérez vos équipes parisiennes avec des expériences qui marquent.",
      context:
        "À Paris, un team building réussi joue sur les contrastes : ateliers créatifs dans les Ateliers de Belleville, chasse au trésor géante Paris Centre, escape game au Louvre après la fermeture, régate en Seine, atelier chef au Cordon Bleu. Nous exploitons toute la palette d'expériences urbaines & culturelles de la capitale.",
      activities: [
        "Chasse au trésor Paris Centre avec QR codes",
        "Escape game privatisé au Louvre (après horaires)",
        "Atelier chef au Cordon Bleu ou Ferrandi",
        "Régate en Seine ou canaux Saint-Martin",
        "Tour street-art Belleville & Butte-aux-Cailles",
        "Escape game réalité virtuelle multi-joueurs",
      ],
    },
  },
  lyon: {
    name: "Lyon",
    region: "Auvergne-Rhône-Alpes",
    coords: { lat: 45.7640, lng: 4.8357 },
    fetesNoel: {
      hook: "La ville des Lumières met en scène votre fin d'année.",
      context:
        "Lyon offre le cadre idéal pour une fête de Noël d'entreprise entre Fête des Lumières (8 décembre), Halles Paul Bocuse, bouchons authentiques et lieux d'exception comme la Sucrière ou le Musée des Confluences. Notre implantation à Lyon (Tour Part-Dieu) nous permet de coordonner votre événement de A à Z en direct.",
      venues: [
        "La Sucrière & les Halles Paul Bocuse",
        "Musée des Confluences (privatisations)",
        "Hôtels 5★ (Villa Florentine, InterContinental Grand Hôtel-Dieu)",
        "Péniches sur le Rhône et la Saône",
        "Traboules & caves voûtées du Vieux-Lyon (UNESCO)",
        "Rooftops Part-Dieu vue sur Fourvière",
      ],
    },
    teamBuilding: {
      hook: "Renforcez la cohésion à Lyon, capitale gastronomique.",
      context:
        "À Lyon, on associe expérience gastronomique et cohésion : ateliers cuisine dans les bouchons, dégustation de vins Beaujolais/Côtes du Rhône, chasse au trésor traboules Vieux-Lyon, atelier chocolatier avec un MOF, escape game au Musée Miniature & Cinéma.",
      activities: [
        "Atelier cuisine dans un bouchon lyonnais",
        "Dégustation Beaujolais & Côtes du Rhône",
        "Chasse au trésor traboules du Vieux-Lyon",
        "Atelier chocolatier avec MOF (Meilleur Ouvrier de France)",
        "Rallye vélo entre Presqu'île et Confluence",
        "Escape game Musée Miniature",
      ],
    },
  },
  marseille: {
    name: "Marseille",
    region: "Provence-Alpes-Côte d'Azur",
    coords: { lat: 43.2965, lng: 5.3698 },
    fetesNoel: {
      hook: "Fêtez Noël face à la Méditerranée.",
      context:
        "Marseille apporte à vos fêtes de fin d'année ce que aucune autre ville française ne peut offrir : la mer, le soleil doux de décembre et une gastronomie provençale singulière. MuCEM, calanques, villas de Provence : nous privatisons les plus beaux espaces marseillais.",
      venues: [
        "MuCEM (privatisation panoramique)",
        "Villas privées face aux Calanques",
        "Palais du Pharo",
        "Hôtels 5★ (InterContinental Hôtel-Dieu, NH Collection)",
        "Yachts privatisés dans le Vieux-Port",
        "Bastides provençales aux portes de la ville",
      ],
    },
    teamBuilding: {
      hook: "Vivez la Méditerranée pour souder vos équipes.",
      context:
        "Marseille est une des rares villes françaises où on peut faire du kayak dans les Calanques le matin et participer à un cours de bouillabaisse l'après-midi. Nos programmes team building exploitent le littoral, les îles du Frioul, la Provence et la gastronomie locale.",
      activities: [
        "Kayak dans les Calanques (Sormiou, Morgiou)",
        "Régate au départ du Vieux-Port",
        "Cours de bouillabaisse traditionnelle",
        "Rallye pétanque sur la Corniche",
        "Escape game au MuCEM ou dans un fort d'If",
        "Randonnée VTT électrique dans les Calanques",
      ],
    },
  },
  bordeaux: {
    name: "Bordeaux",
    region: "Nouvelle-Aquitaine",
    coords: { lat: 44.8378, lng: -0.5792 },
    fetesNoel: {
      hook: "Bordeaux, capitale mondiale du vin, met en lumière votre fin d'année.",
      context:
        "Bordeaux allie patrimoine UNESCO, chais mythiques et scène gastronomique de très haut niveau. Idéal pour une fête de Noël d'entreprise chic et raffinée dans les Chartrons ou au coeur d'un château du Médoc.",
      venues: [
        "Cité du Vin (privatisation)",
        "Chais des Chartrons (dégustation privée)",
        "Châteaux du Médoc et de Saint-Émilion",
        "Palais de la Bourse & Grand Théâtre",
        "Hôtels 5★ (InterContinental Le Grand Hôtel, Yndo)",
        "Péniches sur la Garonne",
      ],
    },
    teamBuilding: {
      hook: "Fédérez autour de l'art du vin et de la table bordelaise.",
      context:
        "À Bordeaux, un team building est presque toujours autour du vin : dégustation à l'aveugle, création d'un assemblage propre à l'équipe, visite privée de château, atelier accord mets/vins avec un sommelier étoilé. Un format qui séduit particulièrement les équipes commerciales et dirigeantes.",
      activities: [
        "Dégustation à l'aveugle (défi par équipes)",
        "Création d'un assemblage 'cuvée entreprise'",
        "Visite privée de château au Médoc ou Saint-Émilion",
        "Rallye vélo dans les vignes",
        "Atelier accord mets/vins avec un sommelier étoilé",
        "Régate sur la Garonne",
      ],
    },
  },
  lille: {
    name: "Lille",
    region: "Hauts-de-France",
    coords: { lat: 50.6292, lng: 3.0573 },
    fetesNoel: {
      hook: "Le charme flamand pour vos fêtes de fin d'année.",
      context:
        "Lille est LA ville de Noël en France (marché de Noël géant, esprit flamand chaleureux). Sa proximité avec la Belgique et le Royaume-Uni en fait un point de rendez-vous idéal pour les équipes internationales.",
      venues: [
        "Palais des Beaux-Arts (privatisation)",
        "Vieux-Lille (restaurants et caves d'exception)",
        "Gare Saint-Sauveur",
        "Hôtels 5★ (Clarance, Barrière Lille)",
        "Le Tripostal (ancien centre de tri postal)",
        "Estaminets & brasseries typiques",
      ],
    },
    teamBuilding: {
      hook: "L'esprit du Nord au service de vos équipes.",
      context:
        "Lille propose un team building convivial et abordable : tours brasseries, atelier estaminet, karting couvert, escape room à la Piscine de Roubaix (musée). Position stratégique pour les équipes réparties Paris-Bruxelles-Londres.",
      activities: [
        "Tour des brasseries artisanales du Nord",
        "Atelier gaufre & carbonade flamande",
        "Escape game à La Piscine de Roubaix (musée)",
        "Karting couvert (indoor Lille)",
        "Rallye photo dans le Vieux-Lille",
        "Cours de peinture façon Rembrandt (musée)",
      ],
    },
  },
  toulouse: {
    name: "Toulouse",
    region: "Occitanie",
    coords: { lat: 43.6047, lng: 1.4442 },
    fetesNoel: {
      hook: "La ville rose sublime vos fêtes de fin d'année.",
      context:
        "Toulouse, capitale française de l'aéronautique et de l'espace, offre des lieux uniques pour vos fêtes de Noël d'entreprise : Cité de l'Espace, hangars historiques d'Airbus, hôtels particuliers en brique rose, péniches sur le canal du Midi.",
      venues: [
        "Cité de l'Espace (privatisation)",
        "Ancien hangar Airbus Envol des Pionniers",
        "Hôtels particuliers en brique rose",
        "Péniches sur le canal du Midi",
        "Hôtels 5★ (Grand Hôtel de l'Opéra, La Cour des Consuls)",
        "Domaines viticoles aux portes de la ville",
      ],
    },
    teamBuilding: {
      hook: "Volez plus haut avec un team building toulousain.",
      context:
        "À Toulouse, l'aéronautique inspire nos team building : simulateur de vol pilotable en équipe, visite privée Airbus (Concorde Musée), rugby amateur au Stade Toulousain, dégustation cassoulet et Fronton.",
      activities: [
        "Simulateur de vol A320 (challenge équipes)",
        "Visite privée Airbus Aéroscopia",
        "Rugby amateur au Stade Toulousain",
        "Dégustation cassoulet & vin de Fronton",
        "Balade en gabarre sur le canal du Midi",
        "Escape game Cité de l'Espace",
      ],
    },
  },
  nantes: {
    name: "Nantes",
    region: "Pays de la Loire",
    coords: { lat: 47.2184, lng: -1.5536 },
    fetesNoel: {
      hook: "Nantes créative pour une fin d'année différente.",
      context:
        "Nantes, capitale culturelle et créative de l'Ouest, propose des lieux insolites : Machines de l'Île, Île de Versailles, Château des Ducs, Hangar à Bananes. Idéal pour des fêtes de Noël d'entreprise à l'ambiance décalée et branchée.",
      venues: [
        "Machines de l'Île (privatisation nocturne)",
        "Château des Ducs de Bretagne",
        "Hangar à Bananes (LU, HAB)",
        "Nef des Chantiers Nefiliens",
        "Hôtels 5★ (Radisson Blu Palais de la Bourse, Sozo)",
        "Bateaux sur l'Erdre",
      ],
    },
    teamBuilding: {
      hook: "Créativité et audace nantaises pour vos équipes.",
      context:
        "Nantes cultive l'esprit d'innovation. Nos team building nantais surprennent : parcours dans les Machines de l'Île, escape game au Château des Ducs, rallye street-art à travers la ville, atelier LU dans l'ancienne usine.",
      activities: [
        "Parcours nocturne aux Machines de l'Île",
        "Escape game au Château des Ducs de Bretagne",
        "Rallye street-art (Le Voyage à Nantes)",
        "Atelier biscuiterie LU dans l'ancienne usine",
        "Croisière sur l'Erdre (dîner-croisière)",
        "Régate en catamaran sur la Loire",
      ],
    },
  },
  strasbourg: {
    name: "Strasbourg",
    region: "Grand Est",
    coords: { lat: 48.5734, lng: 7.7521 },
    fetesNoel: {
      hook: "La capitale de Noël vous accueille.",
      context:
        "Strasbourg est LA capitale française de Noël (marché de Noël depuis 1570, sapin géant place Kléber). Aucune autre ville n'offre une atmosphère aussi authentique pour votre fête de fin d'année d'entreprise. Cadre franco-allemand, gastronomie alsacienne raffinée.",
      venues: [
        "La Petite France (privatisation restaurant winstub)",
        "Palais Rohan (privatisations exceptionnelles)",
        "Caves alsaciennes des Chevaliers",
        "Bateaux Batorama sur l'Ill",
        "Hôtels 5★ (Cour du Corbeau, Régent Petite France)",
        "Château du Haut-Barr aux portes de la ville",
      ],
    },
    teamBuilding: {
      hook: "L'esprit franco-allemand pour vos équipes.",
      context:
        "Strasbourg est unique en France : à cheval sur deux cultures, elle propose des expériences que l'on ne trouve nulle part ailleurs. Atelier bretzel & choucroute, dégustation Riesling/Gewurztraminer, escape game à la Cathédrale.",
      activities: [
        "Atelier bretzel & choucroute traditionnelle",
        "Route des Vins d'Alsace (Riesling, Gewurztraminer)",
        "Escape game à la Cathédrale de Strasbourg",
        "Balade vélo transfrontalière France-Allemagne",
        "Rallye photo dans la Petite France",
        "Visite privée du Parlement européen",
      ],
    },
  },
  nice: {
    name: "Nice",
    region: "Provence-Alpes-Côte d'Azur",
    coords: { lat: 43.7102, lng: 7.2620 },
    fetesNoel: {
      hook: "Fêtez Noël sous le soleil de la Côte d'Azur.",
      context:
        "Nice offre en décembre un cadre unique : 15-18°C, palmeraie en fleurs, Promenade des Anglais. L'idéal pour une fête de Noël d'entreprise différenciante, à la fois festive et solaire.",
      venues: [
        "Hôtel Negresco (privatisation salons)",
        "Villa Ephrussi de Rothschild",
        "Palais de la Méditerranée",
        "Rooftops Promenade des Anglais",
        "Yachts privatisés au Port de Nice",
        "Domaines & villas sur les hauteurs de Nice",
      ],
    },
    teamBuilding: {
      hook: "La Côte d'Azur pour souder vos équipes.",
      context:
        "Nice est le hub de la Côte d'Azur : mer chaude à courte distance, ambiance internationale, gastronomie niçoise. Nos programmes team building mêlent nautique, œnologie provençale et culture méditerranéenne.",
      activities: [
        "Régate en catamaran Nice-Monaco",
        "Atelier socca & pan bagnat traditionnel",
        "Rallye entre Nice-Èze-Monaco",
        "Dégustation vins de Bellet (rare AOC niçois)",
        "Escape game au Musée Chagall",
        "Randonnée hors-sentier sur la Côte d'Azur",
      ],
    },
  },
  montpellier: {
    name: "Montpellier",
    region: "Occitanie",
    coords: { lat: 43.6108, lng: 3.8767 },
    fetesNoel: {
      hook: "Le sud dynamique pour votre fin d'année.",
      context:
        "Montpellier, une des villes les plus dynamiques de France, propose un cadre méditerranéen doux et une scène culturelle vive. Idéal pour les entreprises de la tech, de la santé et de l'e-commerce implantées dans le sud.",
      venues: [
        "Château Flaugergues (privatisation)",
        "Place de la Comédie & Opéra",
        "Corum de Montpellier",
        "Domaines viticoles du Languedoc",
        "Hôtels 5★ (Domaine de Verchant, Pullman Antigone)",
        "Salles atypiques à Antigone",
      ],
    },
    teamBuilding: {
      hook: "Le dynamisme méditerranéen au service de vos équipes.",
      context:
        "Montpellier associe le sud, l'université et la tech. Nos team building s'articulent autour de la mer (Palavas à 20 min), du vignoble Languedocien et des expériences culturelles.",
      activities: [
        "Voile & paddle sur l'étang de Palavas",
        "Dégustation vins Languedoc-Roussillon",
        "Escape game dans le Vieux Montpellier",
        "Atelier huile d'olive & tapenade",
        "Rallye vélo Pic-Saint-Loup",
        "Visite privée Domaine de Verchant",
      ],
    },
  },
};

export const SERVICE_CITY_ORDER = ["paris", "lyon", "marseille", "bordeaux", "lille", "toulouse", "nantes", "strasbourg", "nice", "montpellier"];
